window.$ssg = function(gaugeInfo) { // jshint ignore:line

    var metrics = require('./metrics')();
    var Uri = require('./uri');
    var ebayCookies = require('@ebay/cookies-browser');
    var sitespeed = require('@ebay/core-site-speed-ebay');

    return sitespeed(gaugeInfo, Uri, ebayCookies, metrics);

};
